import { Heading as ChakraHeading, HeadingProps as ChakraHeadingProps } from '@chakra-ui/react';
import { ComponentStyleConfig } from '@chakra-ui/theme';
import { specialFont } from 'constants/theme';

const HeadingStyles: ComponentStyleConfig = {
  baseStyle: {
    fontFamily: specialFont,
  },
  sizes: {
    lg: {
      fontSize: 'xl',
    },
  },
};

const Heading = ({ children, as = 'h1', size, ...props }: ChakraHeadingProps) => (
  <ChakraHeading as={as} size={size} {...props}>
    {children}
  </ChakraHeading>
);

export { Heading, HeadingStyles };
